<template>
  <el-dialog
    :title="isNew ? '新增参数' : '修改参数'"
    :visible="formVisible"
    width="30%"
    :show-close="false"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    @closed="cancelForm"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-form-item label="名称" prop="paraName" placeholder="请输入名称">
        <el-input type="text" v-model="ruleForm.paraName"></el-input>
      </el-form-item>
      <el-form-item label="key" prop="paraKey" placeholder="请输入key值">
        <el-input type="text" v-model="ruleForm.paraKey"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入内容"
          v-model="ruleForm.remark"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelForm">取 消</el-button>
      <el-button type="primary" @click="saveForm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addGravitationData, modifyGravitationData } from "@/api/gravitation";
export default {
  data() {
    return {
      isNew: true,
      formVisible: false,
      ruleForm: {
        paraName: "",
        paraKey: "",
        remark: "",
      },
      id: null,
      rules: {
        paraName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        paraKey: [{ required: true, message: "请输入key值", trigger: "blur" }],
      },
    };
  },
  methods: {
    showModal(isNew, row) {
      this.isNew = isNew;
      if (isNew) {
        // 新增
        this.ruleForm = {
          paraName: "",
          paraKey: "",
          remark: "",
        };
        this.id = null;
      } else {
        // 编辑
        this.ruleForm = {
          paraName: row.paraName,
          paraKey: row.paraKey,
          remark: row.remark,
        };
        this.id = row.id;
      }

      this.formVisible = true;
    },
    cancelForm() {
      this.formVisible = false;
    },
    saveForm() {
      if (this.isNew) {
        // 新建
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            addGravitationData({
              ...this.ruleForm,
            }).then(() => {
              this.$message.success("新建成功");
              this.formVisible = false;
              this.$emit("updateTable");
            });
          }
        });
      } else {
        // 编辑
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            modifyGravitationData({
              ...this.ruleForm,
              id: this.id,
            }).then(() => {
              this.$message.success("修改成功");
              this.formVisible = false;
              this.$emit("updateTable");
            });
          }
        });
      }
      
    },
  },
};
</script>
